
import { useEffect } from "react";
import { CheckCircle, ChevronRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const UninstallSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set page title
    document.title = "Uninstalled Successfully!";

    // Event tracking code
    function getUninstallParams() {
      const urlParams = new URLSearchParams(window.location.search);

      return {
        installDate: urlParams.get('install_date'),
        extVersion: urlParams.get('ext_version') || '',
        browser: navigator.userAgent.toLowerCase().includes('firefox') ? 'firefox' : 'chrome',
        source: urlParams.get('source') || 'organic',
        channel: urlParams.get('channel') || '',
        gclid: urlParams.get('gclid') || '',
        campaign: urlParams.get('campaign') || 'organic',
        extName: 'pdf_search',
      };
    }

    function trackUninstall() {
      const params = getUninstallParams();

      if (params.installDate) (window as any).s1.DPL.events.extensions.Uninstall.log(params);
    }

    trackUninstall();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Card className="border-2 border-blue-100 shadow-lg">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto bg-blue-100 rounded-full p-3 mb-4">
              <CheckCircle className="h-8 w-8 text-blue-600" />
            </div>
            <CardTitle className="text-2xl font-bold text-gray-900">Uninstallation Successful</CardTitle>
            <CardDescription className="text-gray-600">
              The PDF Search Helper extension has been removed successfully
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center pt-2">
            <p className="text-gray-700 mb-4">
              The extension has been completely removed from your browser. Thank you for trying PDF Search Helper.
            </p>
          </CardContent>
          <CardFooter className="flex justify-center pb-6">
            <Button 
              onClick={() => navigate("/")} 
              className="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2"
            >
              Go to Homepage Now
              <ChevronRight className="h-4 w-4" />
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default UninstallSuccess;
